export const PINC_CODE_MESSAGES = {
    TITLE: 'Showing centres near ',
    SECOND_TITLE: 'Enter your PIN code',
    EDIT_SUBTEXT:
        'Certain offers might no longer be available after you change your pincode.',
    NOT_SERVICEABLE_SUBTEXT:
        'This helps us show you the nearest ACKO Drive Service Centre and unlock discounts for you',
};
